import * as addApstag from '../../../assets/apstagInit'
import { IBidRequest, IPrebidAdapter } from '../../../typings/IPrebidAdapter'
import { USP } from '../../cmp'
import { Bidder } from '../../enums'
import WebModel from '../../models/WebModel'

export const UAM_CODE = '38918095-8e45-4332-88bf-226b3514cb64'
export const AMAZON_CODE = '3229'

enum PREBID_STATUS_CODES {
  GOOD = 1,
  NO_BID = 2
}

export default class AmazonAdapter implements IPrebidAdapter {
  static amazonTargeting = {}
  code = 'amazon'

  constructor(model: WebModel, gdpr: IGDPR, private _window: Window = window) {
    const pubID = model.uam ? UAM_CODE : AMAZON_CODE
    const initApstag = async () => {
      if (gdpr.enableGdpr) {
        const { TCF } = await import(
          /* webpackChunkName: "gdpr"*/ '../../cmp/tcf/TCF'
        )
        // Wait for GDPR CMP to be ready and then init
        gdpr.onReady(() => {
          this._window.apstag.init({
            pubID,
            gdpr: {
              enabled: true,
              consent: TCF.tcString
            },
            us_privacy: USP.uspString
          })
        })
      } else {
        this._window.apstag.init({
          pubID,
          gdpr: {
            enabled: false
          },
          us_privacy: USP.uspString
        })
      }
    }
    addApstag()
    initApstag()
  }

  callBids(bidRequest: IBidRequest, addBidResponse, done): void {
    const adunits: Array<{
      slotID: string
      sizes: AdSizes
    }> = []

    bidRequest.bids.forEach((bid) => {
      // Remove previous targeting for this ad unit
      delete AmazonAdapter.amazonTargeting[bid.adUnitCode]

      // Add to array we're going to request
      adunits.push({
        slotID: bid.adUnitCode,
        sizes: [bid.sizes[0]]
      })
    })

    this._window.apstag.fetchBids({ slots: adunits }, (amazonBids) => {
      amazonBids.forEach((amazonBid) => {
        AmazonAdapter.amazonTargeting[amazonBid.slotID] = {
          amznbid: amazonBid.amznbid,
          amzniid: amazonBid.amzniid,
          amznsize: amazonBid.size
        }
      })

      // Return blank ads to trigger Prebid aution ending
      adunits.forEach((adunit) => {
        const bidObject = this._window.pbjs.createBid(
          PREBID_STATUS_CODES.NO_BID
        )
        bidObject.bidderCode = Bidder.uam
        addBidResponse(adunit.slotID, bidObject)
      })

      // We're done
      done()
    })
  }
}
